import utils from 'utils';

import {useNavigate} from 'react-router-dom';
import {useEffect, useContext, useState} from 'react';

import {
    BigTitle,
    ProductsControlBar,
    ProductsGrid,
    ProductsList,
    UiButton,
} from '@components/export';
import {useLabel} from '@/hooks/export';

import useMediaQuery from '@mui/material/useMediaQuery';

import appContext from '@/appContext';

export const ProductsDisplayManager = (props: {
    limit: number,
    isDemo: boolean,
    mode: 'catalog' | 'recommended' | 'alternative',
    alternativeTo?: string,
    purpose?: string,
    useFilters?: boolean,
    initFilters?: any,
    viewMode?: 'grid' | 'list',
}) => {
    const label = useLabel();
    const navigate = useNavigate();
    const isDesktop = useMediaQuery('(min-width: 1024px)');

    const {filters, updateFilters, searchRes, searchResQuery, viewMode, setViewMode, sortModel} = useContext(appContext).productsContext;

    const [allowDisplay, setAllowDisplay] = useState(false);

    const data = {
        productsCount: Array.isArray(searchRes?.pages) && searchRes.pages.at(-1).products.length,
    };

    const flags = {
        noProducts: !searchRes?.pages[0].products.length,
        showMore: data.productsCount >= props.limit,
        isScrollable:
            props.mode === 'alternative' &&
            (isDesktop ? data.productsCount > 4 : data.productsCount > 2),
    };

    const handle = {
        clickLoadMore: () => {
            return props.isDemo ?
                navigate('/catalog') :
                updateFilters({
                    offset: filters.offset + filters.limit,
                });
        },
        cleanFilters() {
            updateFilters({
                attributes: [],
                name: '',
                purpose: '',
            });
        },
        selectFilter: (name: string, value: string) => {
            updateFilters({
                offset: 0,
                attributes: filters.attributes.filter((item) => {
                    return item.name !== name || item.value !== value;
                }),
            });
        },
        toggleViewMode: () => {
            const toSave = viewMode === 'grid' ? 'list' : 'grid'; // fixme refactor

            setViewMode(toSave);

            if (toSave === 'grid') {
                updateFilters({
                    limit: props.limit,
                    offset: 0,
                });
            }

            localStorage.setItem('viewMode', JSON.stringify(toSave));
        },
    };

    useEffect(() => {
        const newFilters = {
            offset: 0,
            limit: props.limit,
            recommended: props.mode === 'recommended',
            alternativeTo: props.mode === 'alternative' ? props.alternativeTo : '',
            attributes: [],
            sort: sortModel,
            useFilters: !!props.useFilters,
            purpose: props.purpose || '',
            ...props.initFilters,
        };

        if (props.mode === 'recommended' || props.mode === 'alternative') {
            newFilters.name = '';
            newFilters.attributes = [];
        }

        if (props.mode === 'recommended') {
            newFilters.purpose = '';
            newFilters.sort = [{field: 'Brand', sort: 'asc'}];
        }

        updateFilters(newFilters);

        if (props.mode !== 'catalog') {
            setViewMode('grid');
        } else {
            setViewMode(JSON.parse(localStorage.getItem('viewMode')) || 'grid');
        }
    }, []);

    useEffect(() => {
        if (!isDesktop && viewMode !== 'grid') {
            setViewMode('grid');
        }
    }, [isDesktop]);

    useEffect(() => {
        setAllowDisplay(true);
    }, [filters.limit]);

    return <div className={cmpClass}>
        {
            props.mode === 'alternative' && !flags.noProducts ?
                <BigTitle title={label.alternativeProducts} dark={true} className={'product-page-products__title'}/> :
                <></>
        }
        {
            props.mode === 'catalog' ?
                <div className={classMap.controlBar}>
                    <ProductsControlBar handle={handle} />
                </div> :
                <></>
        }
        {
            props.mode !== 'alternative' || !flags.noProducts ?
                <>
                    {
                        viewMode === 'grid' ?
                            <ProductsGrid
                                pageSize={props.limit}
                                mode={props.mode}
                                allowDisplay={allowDisplay}
                            /> :
                            <ProductsList
                                allowDisplay={allowDisplay}
                            />
                    }
                    {
                        flags.noProducts || !flags.showMore || props.mode === 'alternative' || viewMode !== 'grid' ?
                            <></> :
                            <div className={classMap.loadMore}>
                                <UiButton
                                    style={1}
                                    text={label.showMore}
                                    onClick={() => handle.clickLoadMore()}
                                    loading={searchResQuery.isFetching}
                                />
                            </div>
                    }
                </> :
                <></>
        }
    </div>;
};

const cmpClass = 'products-display-manager';
const classMap = utils.generateClassMap(cmpClass, {
    controlBar: 'control-bar',
    loadMore: 'load-more',
});
